import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DtpContentContainer,
} from 'dtp-react-components';
import {
  Button,
} from '../../../../components/index';
import { formatarCnpj } from '../../../../utils/helpers';
import {
  trataMensagensErro,
  trataMensagemSucessoBloqueioDesbloqueio,
  doPut,
  doPost,
  doGet,
  validateObject,
  buscaDestinatarios,
  requestApagaFiltroBloqueio,
} from '../../../../utils/requests';
import * as listUtils from '../../../../utils/listsSelect';
import DadosBloqueioDesbloqueio from './DadosBloqueioDesbloqueio';
import ModalAlerta from '../../../requerimentos/ModalAlerta';
import ProtectedItem from '../../../../components/ComponentesAutenticacao/ProtectedItem';
import { msgsConfirmacaoBloqueio, msgsConfirmacaoDesbloqueio } from '../../../../utils/constants';


class BloqueioDesbloqueioEnte extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }
  getInitialState = () => ({
    bloqueio: {
      mesInicioBloqueio: null,
      anoInicioBloqueio: null,
      dataInclusaoBloqueio: null,
      mesFimBloqueio: null,
      anoFimBloqueio: null,
      dataEncerramentoBloqueio: null,
      idParticipante: null,
      tipoBloqueio: null,
      competenciaInicioBloqueio: null,
      competenciaFimBloqueio: null,
      motivoBloqueio: null,
      descricaoMotivo: null,
      tipoDesbloqueio: null,
    },
    participante: {
      codigo: null,
      tipoRegime: null,
      nome: null,
      cnpj: null,
      cnpjEf: null,
      tipoRegimeProprio: null,
      uf: null,
    },
    tipoEntidade: null,
    uf: null,
    bloqueioPesquisa: {
      mesInicioBloqueio: null,
      anoInicioBloqueio: null,
      idParticipante: null,
      tipoBloqueio: null,
      dataInclusaoBloqueio: null,
    },
    existeCompetenciaInicial: true,
    touched: false,
    validadeCampos: {
      tipoBloqueio: false,
      tipoDesbloqueio: false,
    },
    enteBloqueado: true,
    acao: 'novo',
    estadoFormulario: 'inicial',
    showNoContent: false,
    noContentPrimaryMessage: 'Bloqueio não encontrado para o participante informado.',
    noContentSecondaryMessage: 'Informe um cnpj válido.',
    requestPesquisa: null,
    showModalAlerta: false,
    chaveConfirmacao: null,
    listaMotivosBloqueio: [],
    listaMotivosDesbloqueio: [],
    usuarioPossuiPermissaoDesbloqueio: false,
  });

  componentDidMount() {
    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.tratarErro);
    }
    this.montaFormulario();
  }

  handleErrorBusca = () => {
    const mensagemPrimaria = 'Não foi possível consultar o participante.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
      mostraPaginaSemConteudo: true,
      mensagemPrincipalSemConteudo: mensagemPrimaria,
      mensagemSecundariaSemConteudo: mensagemSecundaria,
    });
  }

  buscaDadosParticipanteSuccess = (response) => {
    this.setState({
      participante: { ...this.state.participante, ...response.data },
    });
  };

  handleErrorDadosParticipante = (error) => {
    let mensagemPrimaria = 'Não foi possível consultar o ente federativo.';
    let mensagemSecundaria = 'Contate o administrador do sistema.';
    if (error) {
      if (error.status) {
        if (error.status === 404) {
          mensagemPrimaria = 'Ente Federativo não encontrado para o cnpj informado.';
          mensagemSecundaria = 'Informe um cnpj válido.';
        }
      }
    }
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  handleErrorDadosCompetenciaPagamento = (error) => {
    let mensagemPrimaria = 'Não foi possível consultar a competência de início do bloqueio.';
    let mensagemSecundaria = 'Contate o administrador do sistema.';
    if (error) {
      if (error.status) {
        if (error.status === 404) {
          mensagemPrimaria = 'Competência de início do bloqueio não encontrada.';
          mensagemSecundaria = 'Informe um cnpj válido.';
        }
      }
    }
    this.setState({
      existeCompetenciaInicial: false,
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  buscaDadosCompetenciaPagamentoSuccess = (response) => {
    const { bloqueio } = { ...this.state };
    let objCompetencia = response.data.competencia;
    if (objCompetencia.length !== 7) {
      objCompetencia = `0${objCompetencia}`;
    }
    bloqueio.competenciaInicioBloqueio = objCompetencia;
    this.setState({
      bloqueio: { ...this.state.bloqueio, ...bloqueio },
    });
  };

  handleErrorBusca = () => {
    const mensagemPrimaria = 'Não foi possível consultar.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
      mostraPaginaSemConteudo: true,
      mensagemPrincipalSemConteudo: mensagemPrimaria,
      mensagemSecundariaSemConteudo: mensagemSecundaria,
    });
  }

  buscaDadosParticipante = (idParticipante) => {
    doGet(`participantes-compensacao/codigo/${idParticipante}`, this.buscaDadosParticipanteSuccess, this.handleErrorBusca);
  }

  buscaCompetenciaPagamentoAberta = () => {
    doGet(
      'fechamento-pagamentos/pagamento-aberto',
      this.buscaDadosCompetenciaPagamentoSuccess,
      this.handleErrorDadosCompetenciaPagamento,
    );
  }

  // Motivos de Desbloqueio
  // COMBO DE DESBLOQUEIO = (ORDEM JUDICIAL MAIS O  TIPODOBLOQUEIO)
  // Indice 2 = 'Ordem Judicial'
  montarListaMotivosDesbloqueio = (tipoBloqueio) => {
    const lista = [];
    if (tipoBloqueio !== 2) {
      lista.push({ value: 2, label: listUtils.getObject(listUtils.motivosBloqueio, 2).label });
    }
    lista.push({ value: tipoBloqueio, label: listUtils.getObject(listUtils.motivosBloqueio, tipoBloqueio).label });
    this.setState({
      listaMotivosDesbloqueio: lista,
    });
  }

  montarListaMotivosBloqueio = () => {
    const lista = [];
    if (this.props.auth.checkPermission(['gerenciar-negocio-dcomp'])) {
      lista.push(listUtils.motivosBloqueio[0]);
      lista.push(listUtils.motivosBloqueio[1]);
      lista.push(listUtils.motivosBloqueio[2]);
      lista.push(listUtils.motivosBloqueio[4]);
    }
    if (this.props.auth.checkPermission(['analisar-negocio-sprev'])) {
      lista.push(listUtils.motivosBloqueio[1]);
      lista.push(listUtils.motivosBloqueio[4]);
    }
    if (this.props.auth.checkPermission(['analisar-contrato-dtpv'])) {
      lista.push(listUtils.motivosBloqueio[3]);
    }

    this.setState({
      listaMotivosBloqueio: lista,
    });
  }

  // buscaCompetenciaAtual = () => {
  //   doGet('bloqueio/novo-pagamento', this.buscaCompetenciaAtualSuccess, this.handleErrorBusca);
  // }

  montaFormulario = () => {
    // const cnpj = this.props.match.params.chave.substring(0, 14);
    // this.setState(this.buscaDadosParticipante(cnpj));
    if (this.props.match.params.chave === 'novo') {
      const { filtroBloqueio } = { ...this.props };
      let paramFiltroBloqueio = filtroBloqueio;
      if (paramFiltroBloqueio !== null) {
        paramFiltroBloqueio = JSON.parse(filtroBloqueio);
        const paramDestinatario = paramFiltroBloqueio['destinatario-rpps'];
        const paramTipoEntidade = paramFiltroBloqueio.tipoEntidade;
        const paramUf = paramFiltroBloqueio.uf;
        this.buscaDadosParticipante(paramDestinatario);
        this.setState({
          tipoEntidade: paramTipoEntidade,
          uf: paramUf,
          bloqueio: { idParticipante: paramDestinatario },
        });
      }
      this.montarListaMotivosBloqueio();
      this.setState({
        validadeCampos: {
          ...this.state.validadeCampos,
          tipoDesbloqueio: true,
        },
      }, this.buscaCompetenciaPagamentoAberta);
    } else {
      this.setState({
        acao: this.props.match.params.acao,
        validadeCampos: {
          ...this.state.validadeCampos,
          tipoBloqueio: true,
        },
      }, this.buscaBloqueio);
    }
  }

  trataSucessoResponsePesquisa = (response) => {
    this.setState({
      bloqueio: {
        ...response.data,
      },
      requestPesquisa: null,
    });
  }

  // { value: 1, label: 'CND' },
  // { value: 2, label: 'Ordem Judicial' },
  // { value: 3, label: 'Aluguel' },
  // { value: 4, label: 'Contrato Dataprev' },
  // { value: 5, label: 'Inadimplência' },
  // TABELA BLOQUEIOS
  // Classificador para o tipo de bloqueio  CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
  // CS_TIPO_BLOQUEIO Classificador para o tipo de bloqueio  CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
  // Classificador  do tipo do desbloqueio CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
  // CS_TIPO_DESBLOQUEIO Classificador  do tipo do desbloqueio CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência

  verificarPermissaoDesbloqueio = (tipoBloqueio) => {
    let possuiPermissaoDesbloqueio = false;
    switch (tipoBloqueio) {
      case 1:
        // IB 520538
        if (this.props.auth.checkPermission(['gerenciar-negocio-dcomp', 'analisar-negocio-sprev'])) {
          possuiPermissaoDesbloqueio = true;
        }
        break;
      case 2:
        if (this.props.auth.checkPermission(['gerenciar-negocio-dcomp', 'analisar-negocio-sprev'])) {
          possuiPermissaoDesbloqueio = true;
        }
        break;
      case 3:
        if (this.props.auth.checkPermission(['gerenciar-negocio-dcomp'])) {
          possuiPermissaoDesbloqueio = true;
        }
        break;
      case 4:
        if (this.props.auth.checkPermission(['analisar-contrato-dtpv'])) {
          possuiPermissaoDesbloqueio = true;
        }
        break;
      case 5:
        if (this.props.auth.checkPermission(['gerenciar-negocio-dcomp', 'analisar-negocio-sprev'])) {
          possuiPermissaoDesbloqueio = true;
        }
        break;
      default:
        break;
    }
    this.setState({
      usuarioPossuiPermissaoDesbloqueio: possuiPermissaoDesbloqueio,
    });
  }

  handleSuccessBuscaBloqueio = (response) => {
    const objBloqueio = response.data;
    let objCompetenciaInicio = objBloqueio.competenciaInicioBloqueio;
    let objCompetenciaFim = objBloqueio.competenciaFimBloqueio;

    if (objCompetenciaInicio.length !== 7) {
      objCompetenciaInicio = `0${objCompetenciaInicio}`;
    }
    objBloqueio.competenciaInicioBloqueio = objCompetenciaInicio;

    if (objCompetenciaFim.length !== 7) {
      objCompetenciaFim = `0${objCompetenciaFim}`;
    }
    objBloqueio.competenciaFimBloqueio = objCompetenciaFim;

    this.buscaDadosParticipante(this.state.bloqueioPesquisa.idParticipante);
    objBloqueio.idParticipante = this.state.bloqueioPesquisa.idParticipante;
    this.montarListaMotivosDesbloqueio(response.data.tipoBloqueio);
    this.verificarPermissaoDesbloqueio(response.data.tipoBloqueio);
    this.setState({
      bloqueio: { ...this.state.bloqueio, ...objBloqueio },
    });
  }

  buscaBloqueio = () => {
    const chaveBloqueio = this.props.match.params.chave;
    const tamanhoChave = chaveBloqueio.length;
    const codigo = this.props.match.params.chave.substring(0, 5);
    const datainicio = this.props.match.params.chave.substring(5, tamanhoChave);
    const url = 'bloqueio';

    this.state.bloqueioPesquisa.mesInicioBloqueio = this.props.match.params.mes;
    this.state.bloqueioPesquisa.anoInicioBloqueio = this.props.match.params.ano;
    this.state.bloqueioPesquisa.tipoBloqueio = this.props.match.params.tipo;
    this.state.bloqueioPesquisa.idParticipante = codigo;
    this.state.bloqueioPesquisa.dataInclusaoBloqueio = datainicio;
    doGet(
      url,
      this.handleSuccessBuscaBloqueio,
      this.handleErrorBuscaBloqueio,
      {
        ...this.state.bloqueioPesquisa,
      },
    );
  }

  handleErrorBuscaBloqueio = (error) => {
    // let mensagemPrimaria = 'Não foi possível consultar o bloqueio.';
    // let mensagemSecundaria = 'Contate o administrador do sistema.';
    if (error) {
      if (error.status) {
        this.setState({
          existeCompetenciaInicial: false,
          showNoContent: true,
        });
      }
    }
  }

  formularioProntoParaEnvio = () => {
    const { acao } = { ...this.state };
    if (acao === 'novo' || acao === 'desbloquear-ente') {
      return validateObject(this.state.validadeCampos);
    }
    return false;
  }

  handleChange = (changeObj, name, callback = null) => {
    const { bloqueio } = { ...this.state };
    if (changeObj.value === '' && name === 'tipoEntidade') {
      requestApagaFiltroBloqueio();
      this.setState({
        participante: {
          cnpjEf: changeObj.value,
        },
        bloqueio: {
          idParticipante: changeObj.value,
        },
        uf: '',
        tipoEntidade: '',
      });
    } else if (changeObj.value !== '' &&
      (name === 'uf' || name === 'tipoEntidade')) {
      this.setState({
        participante: {
          cnpjEf: '',
        },
      });
    }
    this.setState({
      [name]: changeObj.value,
      bloqueio: {
        ...bloqueio,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
    }, callback);
  }

  handleChangeComboNome = (changeObj, name) => {
    const { bloqueio } = { ...this.state };
    this.setState(this.buscaDadosParticipante(changeObj.value));
    this.setState({
      [name]: changeObj.value,
      bloqueio: {
        ...bloqueio,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
    });
  }

  addMotivoBloqueioLabel = (tipo) => {
    let valor = '';
    if (tipo) {
      valor = listUtils.getObject(listUtils.motivosBloqueio, tipo).label;
    }
    return valor;
  }

  handleSaveButton = () => {
    let mensagemConfirmacao = '';
    if (this.state.acao === 'novo') {
      mensagemConfirmacao = msgsConfirmacaoBloqueio.bloqueio;
    } else {
      mensagemConfirmacao = msgsConfirmacaoDesbloqueio.desbloqueio;
    }
    this.setState({
      alertas: [mensagemConfirmacao],
      showModalAlerta: !this.state.showModalAlerta,
    });
    // this.confirmSendData();
  }

  /**
   * Trata envio dos dados
   */
  confirmSendData = () => {
    const touched = true;
    const url = 'bloqueio';
    const { validadeCampos } = { ...this.state };
    Object.keys(validadeCampos).forEach((key) => {
      validadeCampos[key] = true;
    });

    this.setState({
      touched,
      validadeCampos,
    }, () => this.handleSave(url));
  }

  /**
   * Trata as acoes dos botao Salvar
   */
  handleSave = (url) => {
    if (this.formularioProntoParaEnvio()) {
      // let options;
      // if (this.state.chaveConfirmacao) {
      //   options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
      // }
      const { bloqueio } = { ...this.state };
      if (bloqueio.motivoBloqueio) {
        bloqueio.descricaoMotivo = this.addMotivoBloqueioLabel(bloqueio.motivoBloqueio);
      }
      // se as duas competencias estiverem preenchidas,
      // é necessario incluir um novo bloqueio para o ente na nova competencia.
      if (bloqueio.competenciaInicioBloqueio && bloqueio.competenciaFimBloqueio) {
        doPut(
          url,
          bloqueio,
          this.trataSucessoResponseEnvio,
          this.trataErrosResponse,
        );
      } else {
        sessionStorage.removeItem('filtroBloqueio');
        doPost(
          url,
          bloqueio,
          this.trataSucessoResponseEnvio,
          this.trataErrosResponse,
        );
      }
    } else {
      trataMensagensErro(['Informe corretamente os atributos indicados na tela.']);
    }
  }

  /**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */
  trataSucessoResponseEnvio = () => {
    this.trataSucesso();
    this.props.history.goBack();
  }

  addMotivoBloqueioDesloqueioLabel = (tipo) => {
    let valor = '';
    if (tipo) {
      valor = listUtils.getObject(listUtils.motivosBloqueio, tipo).label;
    }
    return valor;
  }

  trataSucesso = () => {
    let mensagemSucesso = `O ente federativo  ${this.state.participante.nome}
    ${this.state.participante.uf ? '-' : ''}${this.state.participante.uf}
    ${this.state.participante.cnpjEf ? 'com cnpj' : ''} ${formatarCnpj(this.state.participante.cnpjEf)}
    foi desbloqueado com sucesso pelo motivo
    ${this.addMotivoBloqueioDesloqueioLabel(this.state.bloqueio.tipoDesbloqueio)}
    na competência ${this.state.bloqueio.competenciaFimBloqueio}.`;
    if (this.state.acao === 'novo') {
      mensagemSucesso = `O ente federativo  ${this.state.participante.nome}
      ${this.state.participante.uf ? '-' : ''}${this.state.participante.uf}
      ${this.state.participante.cnpjEf ? 'com cnpj' : ''} ${formatarCnpj(this.state.participante.cnpjEf)}
      foi bloqueado com sucesso pelo motivo
      ${this.addMotivoBloqueioDesloqueioLabel(this.state.bloqueio.tipoBloqueio)}
      na competência ${this.state.bloqueio.competenciaInicioBloqueio}.`;
    }
    trataMensagemSucessoBloqueioDesbloqueio([mensagemSucesso]);
    requestApagaFiltroBloqueio();
  }

  trataErrosResponse = (error) => {
    if (error && error.data) {
      const { data } = { ...error };
      this.setState({
        chaveConfirmacao: data.chaveConfirmacao,
        alertas: data.alertas,
        showModalAlerta: !this.state.showModalAlerta,
      });
    }
  }

  listaFiltradaDestinatarios = () => {
    const listaParticipantes = this.props.destinatarios.filter((item) => {
      if (item.tipoRegimeProprio === this.state.tipoEntidade &&
        ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)) {
        return item;
      }
      return null;
    });
    return listaParticipantes;
  }

  carregaUfDosMunicipios = () => {
    const listaUf = [];
    this.props.destinatarios.forEach((item) => {
      if (item.uf && !listaUf.find(itemLista => itemLista.value === item.uf)) {
        listaUf.push({
          label: item.uf,
          value: item.uf,
        });
      }
    });
    listaUf.sort((a, b) => {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });
    return listaUf;
  }

  trataBotaoVoltar = () => {
    const { filtroBloqueio } = { ...this.props };
    if (filtroBloqueio !== null) {
      requestApagaFiltroBloqueio();
    } else {
      this.props.history.goBack();
    }
  }

  formularioBloqueioEnte = () => (
    <DadosBloqueioDesbloqueio
      acao={this.state.acao}
      auth={this.props.auth}
      estadoFormulario={this.state}
      handleChange={this.handleChange}
      handleChangeComboNome={this.handleChangeComboNome}
      match={this.props.match}
      listaFiltradaDestinatarios={this.listaFiltradaDestinatarios}
      carregaUfDosMunicipios={this.carregaUfDosMunicipios}
    />
  );

  handleFechamentoModalAlerta = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  render() {
    let modalAlerta;
    if (this.state.showModalAlerta) {
      modalAlerta = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.confirmSendData}
        handleModal={this.handleFechamentoModalAlerta}
        showModal
      />);
    }

    const botaoAcaoVoltar = (
      <Button
        className="left"
        onClick={this.props.filtroBloqueio !== null ? this.trataBotaoVoltar() : this.props.history.goBack}
        // onClick={this.props.history.push('/consultaBloqueio/bloqueio')}
        title="Voltar"
        hint="Voltar para tela anterior"
      />
    );

    const botaoAcaoPrincipal = (
      <ProtectedItem allowedPermissions={['gerenciar-negocio-dcomp', 'analisar-negocio-sprev', 'analisar-contrato-dtpv']}>
        {!this.state.bloqueio.dataEncerramentoBloqueio ?
          <Button
            className="dtp-primary right"
            disabled={!this.formularioProntoParaEnvio()}
            title="Salvar"
            onClick={this.handleSaveButton}
            hint="Salvar"
          />
        : '' }
      </ProtectedItem>
    );

    const retorno = (
      <DtpContentContainer>
        {this.formularioBloqueioEnte()}
        <div className="row">
          { botaoAcaoVoltar }
          {(this.state.existeCompetenciaInicial && (this.state.acao !== 'novo' && this.state.usuarioPossuiPermissaoDesbloqueio)) ||
           (this.state.existeCompetenciaInicial && this.state.acao === 'novo') ? botaoAcaoPrincipal : ''}
        </div>
        {modalAlerta}
      </DtpContentContainer>
    );
    return retorno;
  }
}

BloqueioDesbloqueioEnte.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      chave: PropTypes.string,
      mes: PropTypes.string,
      ano: PropTypes.string,
      tipo: PropTypes.string,
      tipoConsulta: PropTypes.string,
    }),
  }),
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  history: PropTypes.shape({
    goBack: PropTypes.function,
  }).isRequired,
  filtroBloqueio: PropTypes.shape({
    'destinatario-rpps': PropTypes.string,
    tipoEntidade: PropTypes.string,
    uf: PropTypes.string,
    competenciaAberta: PropTypes.string,
  }),
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
}.isRequired;

BloqueioDesbloqueioEnte.defaultProps = {
  match: null,
  auth: null,
  destinatarios: [],
  filtroBloqueio: null,
};

const mapStateToProps = state => ({
  destinatarios: state.base.destinatarios,
  filtroBloqueio: state.base.filtroBloqueio,
});

export default connect(mapStateToProps)(BloqueioDesbloqueioEnte);




// WEBPACK FOOTER //
// ./src/pages/cadastros/EntesFederativos/BloqueioDesbloqueio/BloqueioDesbloqueioEnte.jsx